<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="EditPaPayrollIndex" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="名称" prop="PaPayrollIndex.name">
            <el-input class="input-item" v-model="formData.PaPayrollIndex.name"
              :clearable="true" placeholder="名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="描述" prop="PaPayrollIndex.detail">
            <el-input class="input-item" v-model="formData.PaPayrollIndex.detail"
              :clearable="true" placeholder="描述"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="备注" prop="PaPayrollIndex.remark">
            <el-input class="input-item" v-model="formData.PaPayrollIndex.remark"
              :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col class="table-box gutter-bottom" :span="24">
          <el-table ref="paIndexModel" :data="EditPaPayrollIndex.PaIndexModel.impl.dataList" :size="defaultFormItemSize" @sort-change="EditPaPayrollIndex.PaIndexModel.impl.onSortChange"
            header-cell-class-name="table-header-gray" header-row-class-name="hideHeaderCheckBox"
            @select="handleRowClick" row-key="id" default-expand-all height="600px"
          >
            <el-table-column type="selection" width="55px"></el-table-column>
            <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="EditPaPayrollIndex.PaIndexModel.impl.getTableIndex" />
            <el-table-column label="名称" header-align="center" prop="name" width="250px">
            </el-table-column>
            <el-table-column label="参数" header-align="center" prop="paramVariable" width="400px">
              <template slot-scope="scope">
                <span v-if="scope.row.gcode!=='pa_work'">{{scope.row.paramVariable}}</span>
                <div v-if="scope.row.gcode==='pa_work'">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-tag>权重系数：<el-input-number size="mini" v-model="scope.row.pa_work.indexWeightValue" :precision="2" :step="0.01" :max="1" style="width: 100px"/></el-tag>
                    </el-col>
                    <el-col :span="12" v-if="scope.row.code==='work_lv_a_rate'">
                      <el-tag>满分线：<el-input-number size="mini" v-model="scope.row.pa_work.fullScoreLine" :max="100" style="width: 100px"/></el-tag>
                    </el-col>
                    <el-col :span="12" v-if="scope.row.code==='work_lv_a_rate'">
                      <el-tag>扣分系数：<el-input-number size="mini" v-model="scope.row.pa_work.deductionFactor" style="width: 100px"/></el-tag>
                    </el-col>
                  </el-row>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="指标值" prop="indexValue" header-align="center" width="100px">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.indexValue" v-if="scope.row.type==='index'&&scope.row.gcode!=='pa_work'&&scope.row.verifyRule"/>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" header-align="center">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.remark" :disabled="scope.row.remark.indexOf('指标值为')>-1"/>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditPaPayrollIndex:EditPaPayrollIndex:update')"
              @click="onUpdateClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<style>
.hideHeaderCheckBox .el-checkbox__input {
  display: none
}
</style>
<script>
/* eslint-disable-next-line */
import {findTreeNode, findTreeNodePath, findItemFromList, treeDataTranslate} from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaIndexModelController, PaPayrollIndexController, DictionaryController } from '@/api';

export default {
  name: 'EditPaPayrollIndex',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    id: {
      default: undefined
    },
    payrollLineId: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        PaPayrollIndex: {
          id: undefined,
          payrollId: undefined,
          pid: undefined,
          payrollLineId: undefined,
          name: undefined,
          code: undefined,
          gcode: undefined,
          type: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          indexModelId: undefined,
          indexResult: undefined,
          sort: undefined,
          detail: undefined,
          remark: undefined,
          selfId: undefined,
          selfScore: undefined,
          selfAssess: undefined,
          selfAssessTime: undefined,
          superiorScore: undefined,
          superiorAssess: undefined,
          superiorAssessTime: undefined,
          superiorId: undefined,
          judgeAssessLv: undefined,
          judgeId: undefined,
          judgeAssess: undefined,
          judgeAssessTime: undefined,
          judgeScore: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          isDatasourceInit: false
        },
        PaIndexModel: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          paIndexGroup: {
          },
          isDatasourceInit: false
        }
      },
      rules: {
        'PaPayrollIndex.name': [
          {required: true, message: '请输入组名称', trigger: 'blur'}
        ]
      },
      EditPaPayrollIndex: {
        formFilter: {
        },
        formFilterCopy: {
        },
        PaIndexModel: {
          impl: new TableWidget(this.loadPaIndexModelWidgetData, this.loadPaIndexModelVerify, false, false, 'sort', 1)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      if (Array.isArray(row)) {
        row = column;
      }
      let lines = this.$refs.paIndexModel.selection;
      let dataList = this.EditPaPayrollIndex.PaIndexModel.impl.dataList;
      let isInSelection = row === column;
      let groupLines = [];
      for (let i = 0; i < lines.length; i++) {
        if (lines[i] === row) {
          isInSelection = !isInSelection;
        }
        if (lines[i].pid === 1) {
          groupLines.push(lines[i]);
        }
      }

      this.$refs.paIndexModel.toggleRowSelection(row, !isInSelection);

      for (let j = 0; j < dataList.length; j++) {
        // 设置子项
        if (row.pid === 1) {
          for (let i = 0; i < row.children.length; i++) {
            this.$refs.paIndexModel.toggleRowSelection(row.children[i], !isInSelection);
          }
        }
        // 选中父项
        if (!isInSelection && row.pid !== 1 && row.gcode === dataList[j].code) {
          this.$refs.paIndexModel.toggleRowSelection(dataList[j], true);
          break;
        }
      }

      // 清理没有选中子项的行
      for (let j = 0; j < groupLines.length; j++) {
        let hasSelection = false;
        for (let i = 0; i < lines.length; i++) {
          if (lines[i].pid !== 1 && lines[i].gcode === groupLines[j].code) {
            hasSelection = true;
          }
        }
        this.$refs.paIndexModel.toggleRowSelection(groupLines[j], hasSelection);
      }
    },
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 绩效指标模型数据获取函数，返回Promise
     */
    loadPaIndexModelWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params
      }
      return new Promise((resolve, reject) => {
        PaIndexModelController.list(this, params).then(res => {
          let dataList = res.data.dataList;
          for (let i = 0; i < dataList.length; i++) {
            if (dataList[i].gcode === 'pa_work') {
              dataList[i].pa_work = JSON.parse(dataList[i].detail);
            }
          }
          resolve({
            dataList: treeDataTranslate(dataList, 'id', 'pid'),
            totalCount: res.data.totalCount
          });
        }).then(() => {
          this.$nextTick(() => {
            let dataList = this.EditPaPayrollIndex.PaIndexModel.impl.dataList;
            let lines = this.formData.PaPayrollIndex.lines;
            for (let i = 0; i < lines.length; i++) {
              let line = lines[i];
              for (let j = 0; j < dataList.length; j++) {
                let row = dataList[j];
                if (row.id === line.indexModelId) {
                  this.$refs.paIndexModel.toggleRowSelection(row, true);
                  for (let k = 0; k < line.lines.length; k++) {
                    let subLine = line.lines[k];
                    for (let l = 0; l < row.children.length; l++) {
                      let subRow = row.children[l];
                      if (subRow.id === subLine.indexModelId) {
                        subRow.detail = subLine.detail;
                        subRow.remark = subLine.remark;
                        subRow.indexValue = subLine.indexValue;
                        if (subRow.gcode === 'pa_work') {
                          subRow.pa_work = JSON.parse(subLine.detail);
                        }
                        this.$refs.paIndexModel.toggleRowSelection(subRow, true);
                      }
                    }
                  }
                }
              }
            }
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 绩效指标模型数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaIndexModelVerify () {
      return true;
    },
    /**
     * 更新编辑薪资项目
     */
    refreshEditPaPayrollIndex (reloadData = false) {
      this.loadPaPayrollIndexData().then(res => {
        if (reloadData) {
          this.EditPaPayrollIndex.PaIndexModel.impl.refreshTable(true, 1);
        } else {
          this.EditPaPayrollIndex.PaIndexModel.impl.refreshTable();
        }
        if (!this.EditPaPayrollIndex.isInit) {
          // 初始化下拉数据
        }
        this.EditPaPayrollIndex.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      this.$refs.EditPaPayrollIndex.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            ...this.formData.PaPayrollIndex
          };
          this.onCancel(true, formData);
          return;
        }

        let params = {
          paPayrollIndexDto: {
            id: this.formData.PaPayrollIndex.id,
            payrollId: this.formData.PaPayrollIndex.payrollId,
            pid: this.formData.PaPayrollIndex.pid,
            payrollLineId: this.formData.PaPayrollIndex.payrollLineId,
            name: this.formData.PaPayrollIndex.name,
            type: this.formData.PaPayrollIndex.type,
            enableCondition: this.formData.PaPayrollIndex.enableCondition,
            inputVariable: this.formData.PaPayrollIndex.inputVariable,
            paramVariable: this.formData.PaPayrollIndex.paramVariable,
            indexValue: this.formData.PaPayrollIndex.indexValue,
            verifyRule: this.formData.PaPayrollIndex.verifyRule,
            evalFormula: this.formData.PaPayrollIndex.evalFormula,
            taskCode: this.formData.PaPayrollIndex.taskCode,
            indexResult: this.formData.PaPayrollIndex.indexResult,
            indexModelId: this.formData.PaPayrollIndex.indexModelId,
            sort: this.formData.PaPayrollIndex.sort,
            detail: this.formData.PaPayrollIndex.detail,
            remark: this.formData.PaPayrollIndex.remark,
            lines: []
          }
        };
        let lines = this.$refs.paIndexModel.selection;
        let paSalaryLines = [];
        let paWorkLines = [];

        for (let i = 0; i < lines.length; i++) {
          let line = lines[i];
          line.indexModelId = line.id;
          if (line.code === 'pa_salary') {
            line.lines = paSalaryLines;
            params.paPayrollIndexDto.lines.push(line);
          }
          if (line.gcode === 'pa_salary') {
            if (line.verifyRule) {
              let verifyRule;
              // eslint-disable-next-line no-eval
              eval('verifyRule=' + line.verifyRule);
              if (!Array.isArray(verifyRule)) {
                verifyRule = [verifyRule];
              }
              for (let p = 0; p < verifyRule.length; p++) {
                let pattern = new RegExp(verifyRule[p].pattern);
                if (!pattern.test(line.indexValue)) {
                  this.$message.error('[' + line.name + ']' + verifyRule[p].message);
                  return;
                }
              }
            }
            paSalaryLines.push(line);
          }
          if (line.code === 'pa_work') {
            line.lines = paWorkLines;
            params.paPayrollIndexDto.lines.push(line);
          }
          if (line.gcode === 'pa_work') {
            line.detail = line.pa_work;
            paWorkLines.push(line);
          }
        }
        let indexWeightValueSum = 0;
        for (let i = 0; i < paWorkLines.length; i++) {
          let line = paWorkLines[i];
          console.log('indexWeightValue>>>>>>>>>>>>', line.pa_work.indexWeightValue);
          indexWeightValueSum += line.pa_work.indexWeightValue;
          console.log('indexWeightValueSum>>>>>>>>>>>>', indexWeightValueSum);
        }
        console.log('>>>>>>>>>>>>', paWorkLines.length);
        console.log('>>>>>>>>>>>>', indexWeightValueSum);
        console.log('>>>>>>>>>>>>', parseFloat(indexWeightValueSum).toFixed(2));
        if (paWorkLines.length > 0 && parseFloat(indexWeightValueSum).toFixed(2) !== parseFloat(1).toFixed(2)) {
          this.$message.error('所选权重之和应为1');
          return;
        }
        PaPayrollIndexController.update(this, params).then(res => {
          this.$message.success('保存成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    /**
     * 获取工资发放指标详细信息
     */
    loadPaPayrollIndexData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaPayrollIndex.isDatasourceInit) {
          if (this.payrollLineId == null) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            payrollLineId: this.payrollLineId
          };
          PaPayrollIndexController.groupList(this, params).then(res => {
            this.formData.PaPayrollIndex = {...res.data, isDatasourceInit: true};
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaPayrollIndex: {
          id: undefined,
          payrollId: undefined,
          pid: undefined,
          payrollLineId: undefined,
          name: undefined,
          code: undefined,
          gcode: undefined,
          type: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          indexModelId: undefined,
          indexResult: undefined,
          sort: undefined,
          detail: undefined,
          remark: undefined,
          selfId: undefined,
          selfScore: undefined,
          selfAssess: undefined,
          selfAssessTime: undefined,
          superiorScore: undefined,
          superiorAssess: undefined,
          superiorAssessTime: undefined,
          superiorId: undefined,
          judgeAssessLv: undefined,
          judgeId: undefined,
          judgeAssess: undefined,
          judgeAssessTime: undefined,
          judgeScore: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          isDatasourceInit: false
        },
        PaIndexModel: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          paIndexGroup: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshEditPaPayrollIndex();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.PaPayrollIndex = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
